<template>
  <select
    ref="filterSelect"
    class="filter-select pointer"
    :disabled="disabled"
    :title="title"
    @change="$emit('change', $event.target.value)">
    <option
      v-if="defaultOption"
      selected
      value="">
      {{ defaultOption }}
    </option>
    <template v-for="(option, index) of options">
      <option
        :key="`option-${index}`"
        :selected="option.optionSelected"
        :value="option.optionValue">
        {{ option.optionText }}
      </option>
    </template>
  </select>
</template>

<script>
  export default {
    model: {
      event: `change`,
      prop: `value`,
    },
    data() {
      return {};
    },
    computed: {
      transformToLowerKabepCase(text) {
        return text.replace(/([a-z])([A-Z])/g, `$1-$2`)
          .replace(/[\s_]+/g, `-`)
          .toLowerCase();
      },
    },
    props: {
      defaultOption: {
        default: ``,
        type: String,
      },
      disabled: {
        default: false,
        type: Boolean,
      },
      icon: {
        default: ``,
        type: String,
      },
      options: {
        default: () => [],
        type: Array,
      },
      title: {
        default: ``,
        type: String,
      },
    },
    methods: {
      clear() {
        this.$refs.filterSelect.selectedIndex = 0;
      },
      set(value) {
        this.$refs.filterSelect.value = value;
      },
    },
  };
</script>

<style lang="less" scoped>
  @import '../../../assets/styles/rin-variables.less';

  .filter-select {
    background-color: inherit;
    background-position: calc(100% + 25px);
    background-repeat: no-repeat;
    border: 1px solid black;
    font-size: @fontSizeS;
    letter-spacing: 1.5px;
    padding: 10px 40px 10px 10px;

    @media @mobile {
      margin: 25px 0 0 0;
      width: 100%;
    }
  }
</style>
